import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../models/configuration';


@Injectable()
export class ConfigurationService {
  private configData: Configuration;

  // Inject the http service and the app's BASE_URL
  constructor(private http: HttpClient) { }

  loadConfigurationData() {
    const jsonFile = `assets/config/config.json`;
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: Configuration) => {
        this.configData = <Configuration>response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }

  // A helper property to return the config object
  get config(): Configuration {
    return this.configData;
  }
}
